<template>
  <div class="app-layout">
    <ulu-sidebar />
    <div class="main-content" :class="{ 'sidebar-minimized': sidebarMinimized }">
      <b-container fluid>
        <router-view />
        <ulu-loading />
        <ulu-system-restriction-modal />
      </b-container>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";

export default {
  components: {
    "ulu-sidebar": () => import("@/components/navbar/Sidebar"),
    "ulu-loading": () => import("@/components/Loading"),
    "ulu-system-restriction-modal": () =>
      import("@/components/common/SystemRestrictionModal"),
  },
  data() {
    return {
      sidebarMinimized: false
    };
  },
  methods: {
    ...mapActions("axios_mod", ["simpleMutation"])
  },
  mounted() {
    this.$root.$on('sidebar-toggled', (isMinimized) => {
      this.sidebarMinimized = isMinimized;
    });
  },
  beforeDestroy() {
    this.$root.$off('sidebar-toggled');
  },
  beforeCreate() {
    const user = JSON.parse(localStorage.getItem("user"));
    if (user == null) {
      this.$router.push({ name: "login" });
    }
  },
  created() {
    const user = JSON.parse(localStorage.getItem("user"));
    if (user !== null && user.token !== "") {
      this.$store.state.user = user;
      // TODO: Check backend for user
      let data = {
        query: `
          mutation {
            res: UserCheck
          }
        `
      };

      this.simpleMutation({
        data,
        this_ref: this,
        skip_confirm: true
      }).then(res => {});
    } else {
      this.$router.push({ name: "login" });
    }
  }
};
</script>

<style>
.app-layout {
  display: flex;
  min-height: 100vh;
  width: 100%;
}

.main-content {
  flex: 1;
  margin-left: 210px;
  background-color: #f5f6fa;
  min-height: 100vh;
  width: calc(100% - 210px);
  transition: margin-left 0.3s ease, width 0.3s ease;
}

.main-content.sidebar-minimized {
  margin-left: 70px;
  width: calc(100% - 70px);
}

@media (max-width: 768px) {
  .main-content {
    margin-left: 0;
    margin-top: 60px;
    width: 100%;
  }

  .main-content.sidebar-minimized {
    margin-left: 0;
    margin-top: 60px;
    width: 100%;
  }
}
</style>
